import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'periodicity'
})
export class PeriodicityPipe implements PipeTransform {

  transform(value: any, row: any, ...args: any): string {

    if (row.periodicity === 'DAILY') {
      return row.periodicity;
    }

    return `${row.periodicity} (${row.periodicity === 'WEEKLY' ?
      row.firstDayOfWeek : row.firstDayOfMonth})`;
  }
}
